import { Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from 'hooks/useAuth';
import { FullPageLoader } from 'components/FullPageLoader';

export const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const { isAuthenticated, isLoading, redirectToLogin } = useAuth();

  useEffect(() => {
    const hasToken = localStorage.getItem('accessToken');
    if (!hasToken && !isLoading) {
      redirectToLogin();
    }
  }, [isLoading, redirectToLogin]);

  if (isLoading) {
    return <FullPageLoader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  return children;
};
